module.exports = __webpack_public_path__ + "static/img/kols2.6afd25b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols2.png
// module id = h46t
// module chunks = 0